/**
 * Host-platform detection for the capability layer (src/platform/).
 *
 * Contract: every capability has a working web implementation; native
 * branches (via isNativePlatform()) are added in #981 and MUST keep the
 * web fallback. Detection reads the `window.Capacitor` global injected by
 * the future Capacitor shell — it must never import `@capacitor/core`.
 */

interface CapacitorGlobal {
  isNativePlatform?: () => boolean
  getPlatform?: () => string
}

function capacitorGlobal(): CapacitorGlobal | undefined {
  return (globalThis as { Capacitor?: CapacitorGlobal }).Capacitor
}

/** True when running inside a Capacitor native WebView (iOS/Android shell). */
export function isNativePlatform(): boolean {
  return capacitorGlobal()?.isNativePlatform?.() === true
}

/** The host platform; 'web' unless the Capacitor shell reports otherwise. */
export function getPlatform(): 'web' | 'ios' | 'android' {
  const platform = capacitorGlobal()?.getPlatform?.()
  return platform === 'ios' || platform === 'android' ? platform : 'web'
}
